import { AppYeuCauHoTroSelectRequest } from "../../../models/request/app-phuhuynh/AppYeuCauHoTroSelectRequest"
import { AppYeuCauHoTroUpdateRequest } from "../../../models/request/app-phuhuynh/AppYeuCauHoTroUpdateRequest"
import { app_yeu_cau_ho_tro } from "../../../models/response/app-phuhuynh/app_yeu_cau_ho_tro"
import { BaseAction } from "../../actions/IBaseActionResult"
import { IActionTypeBase } from "../IActionTypeBase"


export enum eAppYeuCauHoTroActionTypeIds {
    LOAD_SELECT_START = "APP_YeuCauHoTro_LOAD_SELECT_START",
    LOAD_SELECT_SUCCESS = "APP_YeuCauHoTro_LOAD_SELECT_SUCCESS",
    LOAD_SELECT_ERROR = "APP_YeuCauHoTro_LOAD_SELECT_ERROR",

    LOAD_DETAIL_START = "APP_YeuCauHoTro_LOAD_DETAIL_START",
    LOAD_DETAIL_SUCCESS = "APP_YeuCauHoTro_LOAD_DETAIL_SUCCESS",
    LOAD_DETAIL_ERROR = "APP_YeuCauHoTro_LOAD_DETAIL_ERROR",

    UPDATE_PHANHOI_START = "APP_YeuCauHoTro_UPDATE_PHANHOI_START",
    UPDATE_PHANHOI_SUCCESS = "APP_YeuCauHoTro_UPDATE_PHANHOI_SUCCESS",
    UPDATE_PHANHOI_ERROR = "APP_YeuCauHoTro_UPDATE_PHANHOI_ERROR",
}

export interface IAppYeuCauHoTroLoadDetailStart extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.LOAD_DETAIL_START, number> { };
export interface IAppYeuCauHoTroLoadDetailSuccess extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.LOAD_DETAIL_SUCCESS, app_yeu_cau_ho_tro> { };
export interface IAppYeuCauHoTroLoadDetailErr extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.LOAD_DETAIL_ERROR, string> { };

export interface IAppYeuCauHoTroLoadSelectStart extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.LOAD_SELECT_START, AppYeuCauHoTroSelectRequest> { };
export interface IAppYeuCauHoTroLoadSelectSuccess extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.LOAD_SELECT_SUCCESS, app_yeu_cau_ho_tro[]> { };
export interface IAppYeuCauHoTroLoadSelectErr extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.LOAD_SELECT_ERROR, string> { };

export interface IAppYeuCauHoTroUpdatePhanHoiStart extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.UPDATE_PHANHOI_START, AppYeuCauHoTroUpdateRequest> { };
export interface IAppYeuCauHoTroUpdatePhanHoiSuccess extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.UPDATE_PHANHOI_SUCCESS, undefined> { };
export interface IAppYeuCauHoTroUpdatePhanHoiErr extends IActionTypeBase<eAppYeuCauHoTroActionTypeIds.UPDATE_PHANHOI_ERROR, string> { };


export type IAppYeuCauHoTroActionTypes =
    IAppYeuCauHoTroLoadSelectStart | IAppYeuCauHoTroLoadSelectSuccess | IAppYeuCauHoTroLoadSelectErr |
    IAppYeuCauHoTroLoadDetailStart | IAppYeuCauHoTroLoadDetailSuccess | IAppYeuCauHoTroLoadDetailErr |
    IAppYeuCauHoTroUpdatePhanHoiStart | IAppYeuCauHoTroUpdatePhanHoiSuccess | IAppYeuCauHoTroUpdatePhanHoiErr 